export default "__VITE_ASSET__BaI2ixJH__"